import React, { Fragment } from 'react';

import Box from '@material-ui/core/Box';

import useStyles from './Statistics.styled';
import { Divider } from '@material-ui/core';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';

const StatisticsCard = ({ children, data = {}, status, customClasses }) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.container} ${classes[status]} ${customClasses?.container || ''}`}>
      <div className={`${classes.widgetIcon} ${classes[status + 'Icon']}`}>{children}</div>
      <div className={`${classes.data} ${status}`}>
        {Object.keys(data).map((key, index) => (
          <Fragment key={index}>
            <div className={classes.widgetContent}>
              <span className={classes.widgetValue}>{data[key]}</span>
              <span className={classes.widgetLabel}>{i18n.t(`statistics.${key}`)}</span>
            </div>
            {Object.keys(data).length !== index + 1 && (
              <Divider
                className={`${classes.divider} ${classes[status + 'Divider']}`}
                orientation="vertical"
              />
            )}
          </Fragment>
        ))}
      </div>
    </Box>
  );
};

StatisticsCard.propTypes = {
  data: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  customClasses: PropTypes.object.isRequired,
  status: PropTypes.oneOf(['available', 'offline', 'lateReturn', 'reserved']),
};

StatisticsCard.defaultProps = {
  data: [],
  status: '',
  customClasses: {},
};

export default StatisticsCard;
